<div #container class="ocl-container-with-padding" style="height: 90%">
    <div #controls>
      <h4>{{ label }}</h4>
      <div fxLayout="row" fxLayoutAlign="space-between">
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between" [style]="{height: editorHeight}">
        <dx-html-editor #editor [width]="'100%'" [height]="'100%'" valueType="html" (valueChange)="htmlChanged($event)" [disabled]="disabled">
            <dxo-toolbar *ngIf="!simpleMode">
                <dxi-item name="undo"></dxi-item>
                <dxi-item name="redo"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <!--<dxi-item
                    name="size"
                    [formatValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"
                ></dxi-item>
                <dxi-item
                    name="font"
                    [formatValues]="[
                        'Arial',
                        'Courier New',
                        'Georgia',
                        'Impact',
                        'Lucida Console',
                        'Tahoma',
                        'Times New Roman',
                        'Verdana'
                    ]"
                ></dxi-item>
                <dxi-item name="separator"></dxi-item>-->
                <dxi-item name="bold"></dxi-item>
                <dxi-item name="italic"></dxi-item>
                <dxi-item name="strike"></dxi-item>
                <dxi-item name="underline"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="alignLeft"></dxi-item>
                <dxi-item name="alignCenter"></dxi-item>
                <dxi-item name="alignRight"></dxi-item>
                <dxi-item name="alignJustify"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="header" [formatValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="orderedList"></dxi-item>
                <dxi-item name="bulletList"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="color"></dxi-item>
                <dxi-item name="background"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="link"></dxi-item>
               <!-- <dxi-item name="image"></dxi-item>-->
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="clear"></dxi-item>
                <dxi-item name="codeBlock"></dxi-item>
                <dxi-item name="blockquote"></dxi-item>
            </dxo-toolbar>
            <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
        </dx-html-editor>
    </div>
</div>
